import { sum } from 'lodash-es'
import { type Descendant, Text } from 'slate'

import logger from '@/utils/logger'

import deserializeRichText from './deserializeRichText'
import type { SerializedRichText } from './types'

const MAX_DEPTH = 1000
function countCharactersInner(nodes: Descendant[], depth = 0): number {
  if (depth > MAX_DEPTH) {
    logger.error('Max depth exceeded in countCharacters', { nodes })
    return 0
  }
  return sum(
    nodes.map(node =>
      Text.isText(node) ? node.text.length : countCharactersInner(node.children, depth + 1)
    )
  )
}

export default function countCharacters(value: SerializedRichText): number {
  if (value.serialization_method === 'slate_json_v1') {
    return countCharactersInner(deserializeRichText(value))
  }

  return value.content.length
}
